import React from 'react';
import { connect } from 'react-redux';
import { getMasterData } from '../../AddComplain/api';
import { addVcReport, getVcUploadHistory } from './api';
import PhotoUploadScreen from '../../../components/officerShell/PhotoUploadScreen';

const VcReport = (props) => {
    const { districtName, blockName } = props.auth.auth;

    return (
        <PhotoUploadScreen
            eyebrow="VC Node Inspection"
            title="Add VC Document"
            subtitle="कृपया वी.सी की फोटो अपलोड करें"
            item={{ label: 'VC node', labelHi: 'वी.सी नोड', noun: 'VC node', plural: 'VC nodes' }}
            fixedBlock={blockName || ''}
            loadBlocks={async () => {
                const data = await getMasterData(`?type=VC_NODE_BLOCK&districtName=${encodeURIComponent(districtName || '')}`);
                return (data || []).map((d) => String(d.block || '').trim()).filter(Boolean).sort();
            }}
            loadItems={async (block) => {
                const data = await getMasterData(`?type=VC_NODE&blockName=${encodeURIComponent(block)}`);
                return (data || []).map((d) => ({ value: d.id, label: `${d.complexName} (${d.id})` }));
            }}
            upload={({ item, file, date }) => {
                const fd = new FormData();
                fd.append('complexId', item.value);
                fd.append('vcnode', file);
                fd.append('createdAt', date);
                return addVcReport(fd);
            }}
            fetchHistory={getVcUploadHistory}
        />
    );
};

const mapStateToProps = (state) => ({ auth: state.Auth });

export default connect(mapStateToProps)(VcReport);
